import EditorComponent from '@intercom/embercom-composer/components/editor-component';
export default EditorComponent;
